export const handleOnEnterKeyPress = (event: any) => {
  if (event.keyCode === 13 && event.target.nodeName === 'INPUT') {
    const form = event?.target?.form
    if (form) {
      const index = Array.prototype.indexOf.call(form, event.target)
      form?.elements[index + 1].focus()
      event.preventDefault()
    }
  }
}
